import IonIcon from '@reacticons/ionicons'
import { PageLayout } from 'app/views/components/layout/page-layout'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getFacility } from 'app/state/ducks/facilities/selectors'
import {
  Anchor,
  Stack,
  Breadcrumbs,
  Group,
  Menu
} from '@mantine/core'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ContractType } from 'app/models/common-types'
import {
  loadOneFacility,
} from 'app/state/ducks/facilities/thunks'
import { getDeals } from 'app/state/ducks/deals/selectors'
import { getAllLoans } from 'app/state/ducks/loans/selectors'
import { DealParams } from 'app/models/deal-params'
import { loadAllDeals } from 'app/state/ducks/deals/thunks'
import { loadAllFacilityAmendments } from 'app/state/ducks/facility-amendments/thunks'
import { loadAllLoans, loadLoanAmounts, loadLoanHistory } from 'app/state/ducks/loans/thunks'
import { loadNotesByContract } from 'app/state/ducks/notes/thunks'
import FacilityHeader from 'app/views/pages/deals-management/facilities/facility-details/facility-header'
import PIKSchedulerDetails from './pik-schedule-details'
import SegmentControlUpdated from '../segments/segment-control-updated'
import PrimaryInput from '../buttons/PrimaryInput'

export default function PIKSchedulerPage() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()

  const { facilityId, status } = useParams()
  const [, setOpenEdit] = useState(false)
  const [, setDeal] = useState<DealParams | undefined>(undefined)

  const deals = useSelector(getDeals)
  const facility = useSelector(getFacility)
  const loans = useSelector(getAllLoans)
  const facilityLoans = loans.filter((loan) => loan.facilityId.id === facilityId)
  const loan = facilityLoans[0]
  const loanId = loan?.id

  useEffect(() => {
    dispatch(loadAllDeals())
    dispatch(loadAllFacilityAmendments())
    dispatch(loadAllLoans())
  }, [])

  useEffect(() => {
    if (!facilityId) {
      return
    }
    dispatch(loadOneFacility(facilityId ?? '', status ?? ''))
    dispatch(loadNotesByContract(facilityId, ContractType.Facilities))

  }, [facilityId, status])

  useEffect(() => {
    dispatch(loadLoanHistory(loanId ?? ''))
    dispatch(loadLoanAmounts(loanId ?? ''))
  }, [loanId])


  useEffect(() => {
    if (!facility || !deals) {
      return
    }
    const selectedDeal = deals.find(
      (deal: DealParams) => deal.id === facility.dealId.id
    )
    if (!selectedDeal) {
      return
    }
    setDeal(selectedDeal)
  }, [facility, deals])

  const items = [
    { title: 'Deal Management', action: () => navigate('/dealmanagement') },
    {
      title: 'Facilities',
      action: () => navigate('/dealmanagement/facilities')
    },
    {
      title: facility?.name ?? '',
      action: () =>
        navigate(
          `/dealmanagement/facilities/${facility?.id}/${facility?.status}`
        )
    }
  ].map((item, index) => (
    <Anchor
      onClick={() => item.action()}
      key={index}
      color="#374151"
      fw={500}
      fz="14px"
    >
      {item.title}
    </Anchor>
  ))

  const tabs: Record<string, { route: string; label: string; pageRender: JSX.Element }> = {
    pikScheduleCurrent: {
      route: `/dealmanagement/facilities/${facilityId}/${status}/pik-schedule`,
      label: 'CURRENT',
      pageRender: <PIKSchedulerDetails facilityId={facilityId} loan={loan} tab='current' />
    },
    pikScheduleHistory: {
      route: `/dealmanagement/facilities/${facilityId}/${status}/pik-schedule/history`,
      label: 'HISTORY',
      pageRender: <PIKSchedulerDetails facilityId={facilityId} loan={loan} tab='history' />
    },
  }

  const tab = Object.entries(tabs).find(([, t]) => t.route === location.pathname)?.[0]
    ?? Object.keys(tabs)[0]



  return (
    <PageLayout>
      <Stack w="100%">
        <Breadcrumbs
          separator={<IonIcon name="chevron-forward-outline" />}
          mt="xs"
        >
          {items}
        </Breadcrumbs>
        {facility && <FacilityHeader customTitle="PIK Schedule" facility={facility} showStatusPill={false} />}
        <Group w="100%" position="apart" className='tabsGapsActivity'>
          <Group position="right">
            <SegmentControlUpdated tabs={tabs} />
          </Group>
          <Group noWrap></Group>
          <Group noWrap>
            <Menu shadow="md" width={200} position="bottom" withinPortal>
              <Menu.Target>
                <div style={{ width: 'fit-content' }}>
                  <PrimaryInput w='159px'>
                    Actions
                    <IonIcon name='chevron-down-outline' className='primaryInputChevronDown' />
                  </PrimaryInput>
                </div>
              </Menu.Target>
              <Menu.Dropdown>
                {facility?.status?.toLowerCase() !== 'submitted' ? (
                  <Menu.Item
                    icon={<IonIcon className="action-ion-icon" name='settings-outline' />}
                    onClick={() => setOpenEdit(true)}
                  >
                    Edit Next PIK Date
                  </Menu.Item>
                ) : null}
              </Menu.Dropdown>
            </Menu>
          </Group>
        </Group>
        {tabs[tab].pageRender}
      </Stack>
    </PageLayout>
  )
}
